export default {
  setInadimplencia(state, payload) {
    state.inadimplencia = payload
  }
}
